import './style.scss'
import { Button } from 'antd'
import { FC, memo, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getdemoAudios, urlSource } from '@/libs/util'
import { PauseCircleOutlined, PlayCircleOutlined } from '@ant-design/icons'

interface IProps {
  onSelect?: (v: any) => void
}

const AudioDemos: FC<IProps> = (props) => {
  const { t: translate } = useTranslation(['audio_demos'])
  const [previewUrl, setPreviewUrl] = useState<string>(undefined as any)
  const audioRef = useRef<any>()

  useEffect(() => {
    setPreviewUrl('')
    return () => clearEvent()
  }, [])

  useEffect(() => {
    if (previewUrl) {
      clearEvent()
      const audio = new Audio()
      audio.src = urlSource(previewUrl)
      audio.play()
      audioRef.current = audio

      audio.addEventListener('ended', () => {
        setPreviewUrl('')
      })
    } else {
      clearEvent()
    }
  }, [previewUrl])

  const clearEvent = () => {
    if (audioRef.current) {
      audioRef.current.pause()
      audioRef.current = undefined
    }
  }

  return (
    <div className="audio-demo">
      <div className="header-title">
        {translate('audio_demos.example_audio')}
        <span className="yellow">{translate('audio_demos.example_prompt')}</span>
      </div>
      <div className="demo-list">
        {getdemoAudios().map((v) => (
          <div className="list-item" key={v.id}>
            <audio src={urlSource(v.url)} />
            <div className="audio">
              {previewUrl === v.url ? (
                <PauseCircleOutlined onClick={() => setPreviewUrl(undefined as any)} />
              ) : (
                <PlayCircleOutlined onClick={() => setPreviewUrl(v.url)} />
              )}
              <span className="name ellipsis">{v.name}</span>
              <Button type="primary" onClick={() => props.onSelect?.(v)}>
                {translate('audio_demos.select_button')}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default memo(AudioDemos)
